import { render } from "./DisplayByStudents.vue?vue&type=template&id=73764e9b&scoped=true"
import script from "./DisplayByStudents.vue?vue&type=script&lang=js"
export * from "./DisplayByStudents.vue?vue&type=script&lang=js"

import "./DisplayByStudents.vue?vue&type=style&index=0&id=73764e9b&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73764e9b"]])

export default __exports__